import { jsxs, jsx } from 'react/jsx-runtime';
import { colors } from 'nicollet-tokens';

const Checkmark = ({
  className
}) => jsxs("svg", Object.assign({
  height: "16",
  viewBox: "0 0 24 24",
  width: "16"
}, {
  children: [jsx("defs", {
    children: jsx("path", {
      d: "M9.483 17.731L20.748 4.732a1 1 0 1 1 1.512 1.31L10.364 19.768a1 1 0 0 1-1.38.125l-6.863-5.49a1 1 0 0 1 1.25-1.561l6.112 4.89z",
      id: "a"
    }, void 0)
  }, void 0), jsxs("g", Object.assign({
    className: className,
    fill: "none",
    fillRule: "evenodd"
  }, {
    children: [jsx("mask", Object.assign({
      fill: colors.palette.white,
      id: "b"
    }, {
      children: jsx("use", {
        xlinkHref: "#a"
      }, void 0)
    }), void 0), jsx("use", {
      fill: colors.iconFill.onLight,
      fillRule: "nonzero",
      xlinkHref: "#a"
    }, void 0), jsx("path", {
      d: "M0 0h24v24H0z",
      fill: colors.iconFill.onLight,
      mask: "url(#b)"
    }, void 0)]
  }), void 0)]
}), void 0);
Checkmark.displayName = 'Checkmark';

export { Checkmark };
